import * as React from "react";
import styled, { css } from "styled-components";
import CommonSortIcon from "components/common/SortIcon";
const StyledCommonSortIcon = styled(CommonSortIcon)(
  ({ theme, $isRightAligned }) => css`
    display: inline-flex;
    // Mirrors the rest of the header for right-aligned (numeric) columns: the indicator icons sit
    // on the other side of the title there, so the margin needs to face the other way too.
    ${$isRightAligned ? css`
          margin-right: ${theme.spacings.xs};
        ` : css`
          margin-left: ${theme.spacings.xs};
        `}
    padding: 0;
    cursor: pointer;
  `
);
const SORT_DIRECTIONS = {
  ASC: "asc",
  DESC: "desc"
};
const SORT_ORDER_NAMES = {
  asc: "ascending",
  desc: "descending"
};
const SortIcon = ({ column }) => {
  var _a;
  const nextSortDirection = column.getNextSortingOrder() || SORT_DIRECTIONS.ASC;
  const columnMeta = column.columnDef.meta;
  const isRightAligned = ((_a = columnMeta == null ? void 0 : columnMeta.columnRenderer) == null ? void 0 : _a.textAlign) === "right";
  return /* @__PURE__ */ React.createElement(
    StyledCommonSortIcon,
    {
      activeDirection: column.getIsSorted() || null,
      onChange: () => column.toggleSorting(),
      title: `Sort ${columnMeta.label.toLowerCase()} ${SORT_ORDER_NAMES[nextSortDirection]}`,
      ascId: SORT_DIRECTIONS.ASC,
      descId: SORT_DIRECTIONS.DESC,
      $isRightAligned: isRightAligned
    }
  );
};
export default SortIcon;
